import {fetchEntityMetadata, selectMetadata, setMetadata} from 'entities/metadata';
import {EEntityType} from 'shared/constants/entities';
import {TAppState, TDispatch} from 'store/config/types';
import {getBlankForm} from 'utils/common';

import {selectContextRawData} from '../../context/context-selector';
import {setData} from '../data-actions';
import {selectFilterEntityData} from '../data-selectors';

export const initBlankFilter = (entityName: string) => async (
    dispatch: TDispatch, getState: () => TAppState,
) => {
    try {
        let filterMetadata = selectMetadata(entityName, EEntityType.FILTER)(getState());
        const context = selectContextRawData(getState());
        const shouldUpdateMetadata = !filterMetadata;

        if (shouldUpdateMetadata) {
            filterMetadata = (await fetchEntityMetadata(entityName, EEntityType.FILTER))?.data;
            dispatch(setMetadata({entityName, entityType: EEntityType.FILTER, metadata: filterMetadata}));
        }

        const filter = selectFilterEntityData(entityName)(getState());
        const shouldUpdateData = !filter?.data;
        if (shouldUpdateData) {
            const {fields = []} = filterMetadata;
            const filterData = getBlankForm(fields, getState, context);
            dispatch(setData({
                entityName,
                entityType: EEntityType.FILTER,
                data: {
                    id: null,
                    data: filterData,
                    initialData: filterData,
                    loading: true,
                },
            }));
        }
    } catch (e) {
        console.error(e);
    }
};
